function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "43.354",
  height: "33.738"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_4951",
  "data-name": "Group 4951",
  transform: "translate(1.5 1.5)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_128",
  "data-name": "Rectangle 128",
  d: "M0-1.5h32.284a1.5 1.5 0 011.5 1.5v22.956a1.5 1.5 0 01-1.5 1.5H0a1.5 1.5 0 01-1.5-1.5V0A1.5 1.5 0 010-1.5zm30.784 3H1.5v19.956h29.284z",
  transform: "translate(0 7.782)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_190",
  "data-name": "Path 190",
  d: "M41.6-1A1.5 1.5 0 0143.1.5v23.118a1.5 1.5 0 01-.47 1.091l-8.07 7.62a1.5 1.5 0 01-2.53-1.091V8.282a1.5 1.5 0 01.459-1.08L40.553-.58A1.5 1.5 0 0141.6-1zm-1.5 23.972V4.03l-5.075 4.89v18.839z",
  transform: "translate(-1.241 -.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_191",
  "data-name": "Path 191",
  d: "M8.085-1h32.769a1.5 1.5 0 011.041 2.58l-8.07 7.782a1.5 1.5 0 01-1.041.42H.5A1.5 1.5 0 01-.574 7.235L7.011-.547A1.5 1.5 0 018.085-1zm29.052 3H8.717l-4.66 4.782h28.121z",
  transform: "translate(-.5 -.5)"
}))));